"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageEngagementEditorPopover = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PageEngagementPopover_1 = require("Common/Engagement/PageEngagementPopover/PageEngagementPopover");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var UseOpenProjectAnalytics_1 = require("Analytics/Page/UseOpenProjectAnalytics");
var PageEngagementEditorPopover = function (_a) {
    var projectStore = _a.projectStore, isAdmin = _a.isAdmin, optionMenuItemProps = _a.optionMenuItemProps;
    var initialEngagement = projectStore.engagement;
    var _id = projectStore._id, status = projectStore.status;
    var commonState = (0, PageEngagementPopover_1.useCommonPageEngagementPopoverState)(_id, initialEngagement);
    var openProjectAnalytics = (0, UseOpenProjectAnalytics_1.useOpenProjectAnalytics)("project");
    return (react_1.default.createElement(kaleidoscope_1.Popover, { className: "nested-portal", button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, __assign({}, optionMenuItemProps, buttonProps, { closeOnClick: false }), "Engagement")); }, position: kaleidoscope_1.PopoverPosition.Left },
        react_1.default.createElement(PageEngagementPopover_1.PageEngagementPopoverContent, __assign({ pageId: _id, pageStatus: status, isAdmin: isAdmin, canEditProject: (0, Utils_1.isActionAllowed)(status, Types_1.ProjectActions.Edit), onAnalyticsClick: function () { return openProjectAnalytics(projectStore); } }, commonState))));
};
exports.PageEngagementEditorPopover = PageEngagementEditorPopover;
